import store from 'utils/store/withMiddleware'
import { toString } from 'utils/pivot/product'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { BACKEND_PIVOT } from 'core/constants/endpoints'
import { recEngineResponseParser } from 'utils/pivot/recEngineParser'
import { IS_ENROLL } from 'core/constants/environment'
import { propAccessor } from '@hc-frontend/utils'
import isRecommended from 'utils/pivot/plan/isRecommended'

function parseCarrierId(carrierId) {
  return carrierId == 3 ? 'CLIC' : 'NRIC'
}

interface PlanClickRecEngineTrackingArgs {
  planId: Pivot.ObjectKeyType
  policies: number
  period?: Pivot.ObjectKeyType
  argState: Pivot.Store
  storedRecEngine?: Pivot.GenericKeyPair<string> // @Todo: Type out recEngineResponse
}

function planClickRecEngineTracking({
  planId,
  policies,
  period = null,
  argState = null,
  storedRecEngine = null
}: PlanClickRecEngineTrackingArgs) {
  const state = argState || store.getState()
  const recEngine = storedRecEngine || state.recEngine
  if (recEngine) {
    period = period ? period : state.period
    const hcStorage = state.hcStorage
    const plan = state.plans[planId]
    const recommended = isRecommended(plan.planId, state)
    const policyPeriodAccessKey = plan.durations[period]
      ? plan.durations[period]
      : plan.durations[Object.keys(plan.durations).slice(-1)[0]]
    const policy =
      policyPeriodAccessKey['1'] || policyPeriodAccessKey['2'] || policyPeriodAccessKey
    const recommendedPlanArray = IS_ENROLL
      ? state.recommended
        ? state.recommended
        : recEngineResponseParser(storedRecEngine, true)
      : storedRecEngine.data.default || []
    const block =
      recommendedPlanArray.includes(plan.planId) || isRecommended ? 'recommend' : 'main'
    const dataPayload = {
      searchMetaData: {
        order:
          recEngine.order_by === 'plan_id' ? 'default' : recEngine.order_by || 'default',
        placement: hcStorage.placement,
        zipCode: hcStorage.location.zip_code,
        houseHoldSize: hcStorage.household.size,
        eventId: recEngine.event_id || '',
        sessionId: hcStorage.healthcareSession,
        url: window.location.href,
        channel: hcStorage.channel.channelName.toLowerCase(),
        experimentId: recEngine.experiment_id
      },
      result: {
        carrierId: parseCarrierId(plan.carrierId),
        carrierName: state.carriers[plan.carrierId].name,
        deductible: plan.coreBenefits.deductible,
        drugDeductible: `${plan.coreBenefits.deductible} Ded then ${plan.coreBenefits.officeVisitCopay}`,
        oop: plan.coreBenefits.outOfPocketMax,
        planName: plan.planName,
        planType: toString(plan.productId),
        premiumPrepaid: propAccessor(policy, 'prepaid', null)
          ? +policy.prepaid.premium
          : undefined,
        premiumMonthly: +policy.monthly.premium,
        planId: plan.legacyId,
        block,
        position: +this.dataset.index || 0,
        isExtended: +policies > 1
      }
    }
    return fetchJSONHandleError({
      url: `${BACKEND_PIVOT}/click-recommend`,
      data: dataPayload
    })
  }
  return Promise.resolve(false)
}

export default planClickRecEngineTracking
